module.exports = __webpack_public_path__ + "img/04.00d26c1e.jpg";